import { FormattedHTMLMessage, intlShape } from "react-intl";
import React, { PropTypes } from "react/lib/React";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { convertKeysToCamelCase, toCamelCase } from "../form/DBEnumStringHelper";

class OverlayWithToolTip extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.getHoverError = this.getHoverError.bind(this);
        this.getOverlay = this.getOverlay.bind(this);
    }

    getOverlay(iconClass, tooltip, iconImg = null, customComponent = null) {
        if (customComponent) {
            /**
             * If we need to display a toolTip over a certain component, we can
             * pass a custom component to this component. The toolTip will then be 
             * displayed over that custom component.
             */
            return (
                <div className="member-sync-header-tooltip">
                    <OverlayTrigger placement={this.props.placement} overlay={tooltip}>
                        <div>
                            {customComponent}
                        </div>
                    </OverlayTrigger>
                </div>
            );
        }
        else if (iconImg) {
            return (
                <OverlayTrigger placement={this.props.placement} overlay={tooltip}>
                    <div className="sync-logo-container">
                        <img className="sync-img" src={iconImg} />
                    </div>
                </OverlayTrigger>
            );
        }
        return (
            <OverlayTrigger placement={this.props.placement} overlay={tooltip}>
                <div className="sync-logo-container">
                    <span className={iconClass} />
                </div>
            </OverlayTrigger>
        );
    }

    getHoverError() {
        const { errors } = this.props;

        let displayedErrors = [];
        errors.forEach((error) => {
            let displayedError = null;

        if (error.hasOwnProperty("key")) {
            let baseKey = toCamelCase(error["key"]);
            const identifier = error.hasOwnProperty("identifier") ? convertKeysToCamelCase(error["identifier"]) : {};
            let displayedIdentifiers = {};
            Object.keys(identifier).forEach((key) => {
                if (key == "field") {
                    if (identifier["field"] != "" && identifier["field"] != undefined) {
                        displayedIdentifiers[key] = this.context.intl.formatHTMLMessage({
                            id: `clients.client.processSync.errorIdentifiers.fields.${toCamelCase(identifier[key])}`,
                            defaultMessage: identifier[key]
                        });
                    }
                    else {
                        baseKey = `${baseKey}Generic`;
                    }
                } else displayedIdentifiers[key] = toCamelCase(identifier[key]);
            });
            const rawMessage = this.context.intl.formatMessage({ id: `clients.client.processSync.errorIdentifiers.${baseKey}` });
            const variablePattern = /\{(\w+)\}/g;
            const variables = [...rawMessage.matchAll(variablePattern)].map(match => match[1]);
            variables.forEach(variable => {
                if (!displayedIdentifiers.hasOwnProperty(variable)) {
                    displayedIdentifiers[variable] = 'NONE';
                }
            });

            displayedError = this.context.intl.formatMessage(
                {
                    id: `clients.client.processSync.errorIdentifiers.${baseKey}`,
                },
                displayedIdentifiers
            );
        } else displayedError = error["Text"];
            displayedErrors.push(displayedError);
        });
        // If there is more than one error, remove trailing periods and join with semicolons
        if (displayedErrors.length > 1) {
            displayedErrors = displayedErrors.map(error => error.replace(/\.$/, ""));
        }
        return displayedErrors.join("; ");
    }

    render() {
        const { toolTipId, errors, img } = this.props;
        let toolTip = (
            <Tooltip id="tooltip">
                <FormattedHTMLMessage id={toolTipId} />
            </Tooltip>
        );
        if (errors) {
            const errorToDisplay = this.getHoverError(errors, this.context.intl);
            const errorMessages = errorToDisplay.split(";").map((error, index) => {
                error = error.trim();
                return <li key={index}>{error.endsWith('.') ? error : error + '.'}</li>;
            });
            toolTip = (
                <Tooltip id="tooltip">
                    <div className="word-break">
                        <FormattedHTMLMessage id={toolTipId} values={{ error: undefined }} />
                        {<ul>{errorMessages}</ul>}
                    </div>
                </Tooltip>
            );
        }

        if (img) {
            return this.getOverlay(null, toolTip, img);
        }

        const iconClass = toolTipId.includes("Warning")
            ? "icon icon-warning"
            : toolTipId.includes("Started")
                ? "icon icon-loop"
                : "icon icon-checkmark approve-icon-green";

        return this.getOverlay(iconClass, toolTip, null, this.props.customComponent);
    }
}

OverlayWithToolTip.propTypes = {
    errors: PropTypes.array,
    toolTipId: PropTypes.string,
    img: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    placement: PropTypes.string,
    customComponent: PropTypes.object
};

OverlayWithToolTip.defaultProps = {
    placement: "top",
    customComponent: null
};

OverlayWithToolTip.contextTypes = {
    intl: intlShape,
};

export default OverlayWithToolTip;



// WEBPACK FOOTER //
// ./src/components/common/Overlay/OverlayWithToolTip.js